module.exports = __webpack_public_path__ + "static/media/file-exclamation.4b57b938.svg";